// extracted by mini-css-extract-plugin
export default {"component":"ZKf39","block":"EXdDX","title":"FhRYc","text":"T0ncr","navigation":"lJgpJ","navigation-btn":"fLPqs","navigation-btn--disable":"zt6Pa","navigation-icon":"v94Ys"};